export default __webpack_public_path__ + "static/collage-6-87e433aaadc097e9119d051be5090d06.jpg";